export default __webpack_public_path__ + "static/media/super.b85d0c18.svg";